export default {
  isLoading: false,
  showModal: false,
  isModalLoading: false,
}
